import { EEventType } from '../../types/events';
import { EMergeStatus } from '../../types/social';
import { SOCIAL_MERGE_TYPE } from '../../constants/action_types';
import { socialMerge as socialMergeApi } from '../../api/socialMerge';
import { authenticate } from './authenticate';
import { trackSocialMergeSucceed } from '../../utils/tracking';
export function merge(parameters) {
  var socialType = parameters.socialType,
      socialLoginId = parameters.socialLoginId,
      email = parameters.email,
      password = parameters.password;
  return function (dispatch, _getState, context) {
    dispatch({
      type: SOCIAL_MERGE_TYPE,
      status: EMergeStatus.Loading
    });
    return socialMergeApi(context.httpApi, context.subdomain, {
      socialLoginId: socialLoginId,
      email: email,
      password: password
    }).then(function (response) {
      if (response.statusCode === 200) {
        var _response$response = response.response,
            _socialLoginId = _response$response.socialLoginId,
            _email = _response$response.email,
            token = _response$response.token;
        dispatch({
          type: SOCIAL_MERGE_TYPE,
          status: EMergeStatus.Succeed
        });
        context.emitter.emit(EEventType.SocialMergeSucceed);
        trackSocialMergeSucceed();
        dispatch(authenticate({
          socialType: socialType,
          socialLoginId: _socialLoginId,
          email: _email,
          token: token
        }));
        return;
      }

      dispatch({
        type: SOCIAL_MERGE_TYPE,
        status: EMergeStatus.Failed,
        error: response.response.message
      });
    }).catch(function (error) {
      context.logger.error(error);
      dispatch({
        status: EMergeStatus.Failed,
        type: SOCIAL_MERGE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}